// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2NXRs","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__26Lnx"};